// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dashboard Container */
.dashboard-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  flex-direction: column;
}

.dashboard-content {
  flex: 1 1;
  /* display: flex; */
}

.main-content {
  flex: 1 1;
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

/* Loading Screen */
.loading-screen {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.loading-content {
  text-align: center;
  color: white;
  background: rgba(255, 255, 255, 0.1);
  padding: 3rem;
  border-radius: 1rem;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.loading-content h2 {
  margin: 1rem 0 0.5rem 0;
  font-size: 1.5rem;
  font-weight: 600;
}

.loading-content p {
  margin: 0;
  opacity: 0.8;
  font-size: 1rem;
}

/* Welcome Section */
.welcome-section {
  text-align: center;
  margin-bottom: 3rem;
  color: white;
}

.welcome-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  background: linear-gradient(45deg, #fff, #f0f0f0);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.welcome-subtitle {
  font-size: 1.125rem;
  opacity: 0.9;
  margin: 0;
  font-weight: 400;
}

/* Connectors Section */
.connectors-section {
  background: white;
  border-radius: 1rem;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}

.connectors-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem;
  border-bottom: 1px solid #e5e7eb;
  background: #f9fafb;
  /* flex-direction: column; */
}

.connectors-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #111827;
  margin: 0;
}

.add-connector-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: #3b82f6;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.add-connector-button:hover {
  background: #2563eb;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.add-connector-button svg {
  width: 16px;
  height: 16px;
}

/* Connectors Grid */
.connectors-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 1.5rem;
  padding: 2rem;
}

/* Connector Card */
.connector-card {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 0.75rem;
  padding: 1.5rem;
  transition: all 0.2s ease;
  position: relative;
  overflow: hidden;
}

.connector-card:hover {
  border-color: #3b82f6;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
  transform: translateY(-2px);
}

.connector-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #3b82f6, #8b5cf6);
}

/* Connector Header */
.connector-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1.5rem;
  flex-direction: column;
}

.connector-info {
  flex: 1 1;
}

.connector-name {
  font-size: 1.125rem;
  font-weight: 600;
  color: #111827;
  margin: 0 0 0.5rem 0;
}

/* Toggle Switch */
.toggle-switch {
  position: relative;
  width: 48px;
  height: 24px;
  background: #d1d5db;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.toggle-switch.active {
  background: #10b981;
}

.toggle-switch.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.toggle-slider {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  background: white;
  border-radius: 50%;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.toggle-switch.active .toggle-slider {
  transform: translateX(24px);
}

/* Status Badge */
.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.status-active {
  background: #dcfce7;
  color: #166534;
}

.status-inactive {
  background: #fef3c7;
  color: #92400e;
}

.status-error {
  background: #fee2e2;
  color: #991b1b;
}

.status-syncing {
  background: #dbeafe;
  color: #1e40af;
}

.status-unknown {
  background: #f3f4f6;
  color: #374151;
}

/* Connector Details */
.connector-details {
  margin-bottom: 1.5rem;
}

.connector-flow {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
  padding: 1rem;
  background: #f9fafb;
  border-radius: 0.5rem;
}

.flow-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex: 1 1;
  flex-direction: column;
}

.flow-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
  height: auto;
  border-radius: 50%;
  color: white;
}

.flow-icon.source {
  background: #3b82f6;
}

.flow-icon.target {
  background: #10b981;
}

.flow-content {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.flow-label {
  font-size: 0.75rem;
  color: #6b7280;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.flow-value {
  font-size: 0.875rem;
  font-weight: 600;
  color: #111827;
}

.flow-object {
  font-size: 0.75rem;
  color: #6b7280;
}

.flow-arrow {
  color: #9ca3af;
  display: flex;
  align-items: center;
}

/* Connector Meta */
.connector-meta {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.meta-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
  border-bottom: 1px solid #f3f4f6;
}

.meta-item:last-child {
  border-bottom: none;
}

.meta-label {
  font-size: 0.875rem;
  color: #6b7280;
  font-weight: 500;
}

.meta-value {
  font-size: 0.875rem;
  color: #111827;
  font-weight: 600;
}

/* Connector Actions */
.connector-actions {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}
.dashboard-content .connector-actions {
  padding: 1rem;
}
.dashoard-home .toggle-slider {
  width: 0;
}
.action-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  background: white;
  color: #374151;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
}
.dashoard-home .connector-actions {
  border-top: none;
}
.dashoard-home .connector-flow {
  background: none;
}

.action-button:hover {
  background: #f9fafb;
  border-color: #9ca3af;
}

.action-button.secondary {
  border-color: #3b82f6;
  color: #3b82f6;
}

.action-button.secondary:hover {
  background: #eff6ff;
}

.action-button.danger {
  border-color: #ef4444;
  color: #ef4444;
}

.action-button.danger:hover {
  background: #fef2f2;
}

.action-button svg {
  width: 16px;
  height: 16px;
}

/* No Connector State */
.no-connector {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  background: white;
  border-radius: 1rem;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
  text-align: center;
}

.no-connector-icon {
  width: 80px;
  height: 80px;
  margin-bottom: 1.5rem;
  color: #9ca3af;
  cursor: pointer;
  transition: all 0.2s ease;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f3f4f6;
}

.no-connector-icon:hover {
  color: #3b82f6;
  background: #eff6ff;
  transform: scale(1.05);
}

.no-connector-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #111827;
  margin: 0 0 0.5rem 0;
}

.no-connector-text {
  font-size: 1rem;
  color: #6b7280;
  margin: 0 0 2rem 0;
  max-width: 400px;
  line-height: 1.5;
}

/* Primary Button */
.primary-button {
  background: #3b82f6;
  color: white;
  border: none;
  padding: 0.75rem 2rem;
  border-radius: 0.5rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.primary-button:hover {
  background: #2563eb;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

/* Responsive Design */
@media (max-width: 768px) {
  .main-content {
    padding: 1rem;
  }

  .welcome-title {
    font-size: 2rem;
  }

  .connectors-header {
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
  }

  .add-connector-button {
    justify-content: center;
  }

  .connectors-grid {
    grid-template-columns: 1fr;
    padding: 1rem;
  }

  .connector-flow {
    flex-direction: column;
    gap: 1rem;
  }

  .flow-arrow {
    transform: rotate(90deg);
  }

  .connector-actions {
    justify-content: center;
  }

  .action-button {
    flex: 1 1;
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .welcome-title {
    font-size: 1.75rem;
  }

  .connector-card {
    padding: 1rem;
  }

  .connector-header {
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
  }

  .toggle-switch {
    align-self: flex-end;
  }
}

.platform-logo {
  width: 60px;
  height: 60px;
  background: white;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
}

.platform-logo img {
  max-width: 100%;
  max-height: 100%;
}
.platform-logo.hubspot {
  background: #ff7a59;
}
.platform-logo.salesforce {
  background: #00a1e0;
}
.tanent {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  gap: 0.5rem;
}
/* Enhanced Tooltip */
.tooltip {
  position: relative;
  display: inline-block;
  cursor: help;
  padding-left: 5px;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 400px;
  background: #1f2937;
  color: white;
  border-radius: 12px;
  padding: 0;
  position: absolute;
  z-index: 1000;
  opacity: 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

.tooltip .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
  transform: translateY(-5px);
}

.tooltip-content {
  padding: 1rem;
}

.tooltip-header {
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #374151;
  margin-bottom: 0.75rem;
}

.tooltip-header strong {
  font-size: 0.95rem;
  color: #f9fafb;
}

.tooltip-body {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.tooltip-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.85rem;
}

.tooltip-label {
  color: #d1d5db;
  font-weight: 500;
}

.tooltip-value {
  color: #f9fafb;
  font-weight: 600;
  text-align: right;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Enhanced Delete Modal */
.delete-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.delete-modal {
  background: white;
  border-radius: 20px;
  padding: 0;
  max-width: 450px;
  width: 90%;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
  animation: slideUp 0.3s ease;
  overflow: hidden;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.modal-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 2rem 2rem 1rem 2rem;
}

.modal-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-icon.danger {
  background: linear-gradient(135deg, #fee2e2, #fecaca);
  color: #dc2626;
}

.delete-modal h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 700;
  color: #1f2937;
}

.delete-modal p {
  margin: 0 0 2rem 0;
  color: #6b7280;
  line-height: 1.6;
  padding: 0 2rem;
}

.modal-actions {
  display: flex;
  gap: 0.75rem;
  padding: 0 2rem 2rem 2rem;
}

.btn-cancel,
.btn-delete {
  flex: 1 1;
  padding: 0.875rem 1.5rem;
  border-radius: 12px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.btn-cancel {
  background: #f8fafc;
  color: #374151;
  border: 1px solid #e2e8f0;
}

.btn-cancel:hover:not(:disabled) {
  background: #f1f5f9;
  transform: translateY(-1px);
}

.btn-delete {
  background: linear-gradient(135deg, #dc2626, #b91c1c);
  color: white;
  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.3);
}

.btn-delete:hover:not(:disabled) {
  background: linear-gradient(135deg, #b91c1c, #991b1b);
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(220, 38, 38, 0.4);
}

.btn-cancel:disabled,
.btn-delete:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Dashboard.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,6DAA6D;AAC/D;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,iDAAiD;EACjD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,mBAAmB;EACnB;wCACsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;EACX,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB;sCACoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oDAAoD;AACtD;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,SAAO;EACP,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,yBAAyB;EACzB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB;wCACsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,SAAO;IACP,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;AACb;AACA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,iDAAiD;EACjD,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,UAAU;EACV,2CAA2C;EAC3C,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qDAAqD;EACrD,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;;EAEE,SAAO;EACP,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB","sourcesContent":["/* Dashboard Container */\n.dashboard-container {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  display: flex;\n  flex-direction: column;\n}\n\n.dashboard-content {\n  flex: 1;\n  /* display: flex; */\n}\n\n.main-content {\n  flex: 1;\n  padding: 2rem;\n  max-width: 1200px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n/* Loading Screen */\n.loading-screen {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n}\n\n.loading-content {\n  text-align: center;\n  color: white;\n  background: rgba(255, 255, 255, 0.1);\n  padding: 3rem;\n  border-radius: 1rem;\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.loading-content h2 {\n  margin: 1rem 0 0.5rem 0;\n  font-size: 1.5rem;\n  font-weight: 600;\n}\n\n.loading-content p {\n  margin: 0;\n  opacity: 0.8;\n  font-size: 1rem;\n}\n\n/* Welcome Section */\n.welcome-section {\n  text-align: center;\n  margin-bottom: 3rem;\n  color: white;\n}\n\n.welcome-title {\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin-bottom: 0.5rem;\n  background: linear-gradient(45deg, #fff, #f0f0f0);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.welcome-subtitle {\n  font-size: 1.125rem;\n  opacity: 0.9;\n  margin: 0;\n  font-weight: 400;\n}\n\n/* Connectors Section */\n.connectors-section {\n  background: white;\n  border-radius: 1rem;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),\n    0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  overflow: hidden;\n}\n\n.connectors-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 2rem;\n  border-bottom: 1px solid #e5e7eb;\n  background: #f9fafb;\n  /* flex-direction: column; */\n}\n\n.connectors-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #111827;\n  margin: 0;\n}\n\n.add-connector-button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  background: #3b82f6;\n  color: white;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 0.5rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.add-connector-button:hover {\n  background: #2563eb;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);\n}\n\n.add-connector-button svg {\n  width: 16px;\n  height: 16px;\n}\n\n/* Connectors Grid */\n.connectors-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));\n  gap: 1.5rem;\n  padding: 2rem;\n}\n\n/* Connector Card */\n.connector-card {\n  background: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.75rem;\n  padding: 1.5rem;\n  transition: all 0.2s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.connector-card:hover {\n  border-color: #3b82f6;\n  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1),\n    0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  transform: translateY(-2px);\n}\n\n.connector-card::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #3b82f6, #8b5cf6);\n}\n\n/* Connector Header */\n.connector-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 1.5rem;\n  flex-direction: column;\n}\n\n.connector-info {\n  flex: 1;\n}\n\n.connector-name {\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: #111827;\n  margin: 0 0 0.5rem 0;\n}\n\n/* Toggle Switch */\n.toggle-switch {\n  position: relative;\n  width: 48px;\n  height: 24px;\n  background: #d1d5db;\n  border: none;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  flex-shrink: 0;\n}\n\n.toggle-switch.active {\n  background: #10b981;\n}\n\n.toggle-switch.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.toggle-slider {\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 20px;\n  height: 20px;\n  background: white;\n  border-radius: 50%;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.toggle-switch.active .toggle-slider {\n  transform: translateX(24px);\n}\n\n/* Status Badge */\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.25rem 0.75rem;\n  border-radius: 9999px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.status-active {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.status-inactive {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.status-error {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.status-syncing {\n  background: #dbeafe;\n  color: #1e40af;\n}\n\n.status-unknown {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n/* Connector Details */\n.connector-details {\n  margin-bottom: 1.5rem;\n}\n\n.connector-flow {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1rem;\n  padding: 1rem;\n  background: #f9fafb;\n  border-radius: 0.5rem;\n}\n\n.flow-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex: 1;\n  flex-direction: column;\n}\n\n.flow-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: auto;\n  height: auto;\n  border-radius: 50%;\n  color: white;\n}\n\n.flow-icon.source {\n  background: #3b82f6;\n}\n\n.flow-icon.target {\n  background: #10b981;\n}\n\n.flow-content {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.flow-label {\n  font-size: 0.75rem;\n  color: #6b7280;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.flow-value {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #111827;\n}\n\n.flow-object {\n  font-size: 0.75rem;\n  color: #6b7280;\n}\n\n.flow-arrow {\n  color: #9ca3af;\n  display: flex;\n  align-items: center;\n}\n\n/* Connector Meta */\n.connector-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.meta-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5rem 0;\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.meta-item:last-child {\n  border-bottom: none;\n}\n\n.meta-label {\n  font-size: 0.875rem;\n  color: #6b7280;\n  font-weight: 500;\n}\n\n.meta-value {\n  font-size: 0.875rem;\n  color: #111827;\n  font-weight: 600;\n}\n\n/* Connector Actions */\n.connector-actions {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n.dashboard-content .connector-actions {\n  padding: 1rem;\n}\n.dashoard-home .toggle-slider {\n  width: 0;\n}\n.action-button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.375rem;\n  background: white;\n  color: #374151;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-decoration: none;\n}\n.dashoard-home .connector-actions {\n  border-top: none;\n}\n.dashoard-home .connector-flow {\n  background: none;\n}\n\n.action-button:hover {\n  background: #f9fafb;\n  border-color: #9ca3af;\n}\n\n.action-button.secondary {\n  border-color: #3b82f6;\n  color: #3b82f6;\n}\n\n.action-button.secondary:hover {\n  background: #eff6ff;\n}\n\n.action-button.danger {\n  border-color: #ef4444;\n  color: #ef4444;\n}\n\n.action-button.danger:hover {\n  background: #fef2f2;\n}\n\n.action-button svg {\n  width: 16px;\n  height: 16px;\n}\n\n/* No Connector State */\n.no-connector {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 4rem 2rem;\n  background: white;\n  border-radius: 1rem;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),\n    0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  text-align: center;\n}\n\n.no-connector-icon {\n  width: 80px;\n  height: 80px;\n  margin-bottom: 1.5rem;\n  color: #9ca3af;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f3f4f6;\n}\n\n.no-connector-icon:hover {\n  color: #3b82f6;\n  background: #eff6ff;\n  transform: scale(1.05);\n}\n\n.no-connector-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #111827;\n  margin: 0 0 0.5rem 0;\n}\n\n.no-connector-text {\n  font-size: 1rem;\n  color: #6b7280;\n  margin: 0 0 2rem 0;\n  max-width: 400px;\n  line-height: 1.5;\n}\n\n/* Primary Button */\n.primary-button {\n  background: #3b82f6;\n  color: white;\n  border: none;\n  padding: 0.75rem 2rem;\n  border-radius: 0.5rem;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.primary-button:hover {\n  background: #2563eb;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .main-content {\n    padding: 1rem;\n  }\n\n  .welcome-title {\n    font-size: 2rem;\n  }\n\n  .connectors-header {\n    flex-direction: column;\n    gap: 1rem;\n    align-items: stretch;\n  }\n\n  .add-connector-button {\n    justify-content: center;\n  }\n\n  .connectors-grid {\n    grid-template-columns: 1fr;\n    padding: 1rem;\n  }\n\n  .connector-flow {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .flow-arrow {\n    transform: rotate(90deg);\n  }\n\n  .connector-actions {\n    justify-content: center;\n  }\n\n  .action-button {\n    flex: 1;\n    justify-content: center;\n  }\n}\n\n@media (max-width: 480px) {\n  .welcome-title {\n    font-size: 1.75rem;\n  }\n\n  .connector-card {\n    padding: 1rem;\n  }\n\n  .connector-header {\n    flex-direction: column;\n    gap: 1rem;\n    align-items: stretch;\n  }\n\n  .toggle-switch {\n    align-self: flex-end;\n  }\n}\n\n.platform-logo {\n  width: 60px;\n  height: 60px;\n  background: white;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px;\n}\n\n.platform-logo img {\n  max-width: 100%;\n  max-height: 100%;\n}\n.platform-logo.hubspot {\n  background: #ff7a59;\n}\n.platform-logo.salesforce {\n  background: #00a1e0;\n}\n.tanent {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  align-items: center;\n  gap: 0.5rem;\n}\n/* Enhanced Tooltip */\n.tooltip {\n  position: relative;\n  display: inline-block;\n  cursor: help;\n  padding-left: 5px;\n}\n\n.tooltip .tooltiptext {\n  visibility: hidden;\n  width: 400px;\n  background: #1f2937;\n  color: white;\n  border-radius: 12px;\n  padding: 0;\n  position: absolute;\n  z-index: 1000;\n  opacity: 0;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n}\n\n.tooltip .tooltiptext::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 50%;\n}\n\n.tooltip:hover .tooltiptext {\n  visibility: visible;\n  opacity: 1;\n  transform: translateY(-5px);\n}\n\n.tooltip-content {\n  padding: 1rem;\n}\n\n.tooltip-header {\n  padding-bottom: 0.75rem;\n  border-bottom: 1px solid #374151;\n  margin-bottom: 0.75rem;\n}\n\n.tooltip-header strong {\n  font-size: 0.95rem;\n  color: #f9fafb;\n}\n\n.tooltip-body {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.tooltip-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.85rem;\n}\n\n.tooltip-label {\n  color: #d1d5db;\n  font-weight: 500;\n}\n\n.tooltip-value {\n  color: #f9fafb;\n  font-weight: 600;\n  text-align: right;\n  max-width: 300px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Enhanced Delete Modal */\n.delete-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  animation: fadeIn 0.3s ease;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.delete-modal {\n  background: white;\n  border-radius: 20px;\n  padding: 0;\n  max-width: 450px;\n  width: 90%;\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);\n  animation: slideUp 0.3s ease;\n  overflow: hidden;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.modal-header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 2rem 2rem 1rem 2rem;\n}\n\n.modal-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.modal-icon.danger {\n  background: linear-gradient(135deg, #fee2e2, #fecaca);\n  color: #dc2626;\n}\n\n.delete-modal h3 {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #1f2937;\n}\n\n.delete-modal p {\n  margin: 0 0 2rem 0;\n  color: #6b7280;\n  line-height: 1.6;\n  padding: 0 2rem;\n}\n\n.modal-actions {\n  display: flex;\n  gap: 0.75rem;\n  padding: 0 2rem 2rem 2rem;\n}\n\n.btn-cancel,\n.btn-delete {\n  flex: 1;\n  padding: 0.875rem 1.5rem;\n  border-radius: 12px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\n.btn-cancel {\n  background: #f8fafc;\n  color: #374151;\n  border: 1px solid #e2e8f0;\n}\n\n.btn-cancel:hover:not(:disabled) {\n  background: #f1f5f9;\n  transform: translateY(-1px);\n}\n\n.btn-delete {\n  background: linear-gradient(135deg, #dc2626, #b91c1c);\n  color: white;\n  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.3);\n}\n\n.btn-delete:hover:not(:disabled) {\n  background: linear-gradient(135deg, #b91c1c, #991b1b);\n  transform: translateY(-1px);\n  box-shadow: 0 6px 16px rgba(220, 38, 38, 0.4);\n}\n\n.btn-cancel:disabled,\n.btn-delete:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
